import { render, staticRenderFns } from "./douyin-hot-sale.vue?vue&type=template&id=5e8288ea&scoped=true&"
import script from "./douyin-hot-sale.vue?vue&type=script&lang=js&"
export * from "./douyin-hot-sale.vue?vue&type=script&lang=js&"
import style0 from "./douyin-hot-sale.vue?vue&type=style&index=0&id=5e8288ea&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8288ea",
  null
  
)

export default component.exports